import * as React from "react";
import {
    Box,
    Paper,
    Popover,
    Button,
    Grid,
    Backdrop,
    TableContainer,
    Table,
    TableCell,
    TableBody,
    TableRow,
    TableHead,
    List,
    ListItemButton,
    Collapse,
    Typography,
    Stack,
    FormControlLabel,
    Checkbox,
} from "@mui/material";
import { styled, alpha, useTheme } from "@mui/material/styles";
import Menu, { MenuProps } from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import { useState, useEffect, useContext } from "react";
import useMediaQuery from "@mui/material/useMediaQuery";
import { PAGE_SIZE } from "../../Services/common/const";
import Title from "../../Components/Title";
import ShortcutButton from "../../Components/ShortcutButton";
import ArrowBackRoundedIcon from "@mui/icons-material/ArrowBackRounded";
import { PreferencesContext } from "../../PreferencesContext";
import { AlertType } from "../../shared/Modal/AlertType";
import MissingConsumer from "../../Components/MissingConsumer";
import { DateRange } from "react-date-range";
import DateRangeIcon from "@mui/icons-material/DateRange";
import DownloadIcon from "@mui/icons-material/Download";
import { format } from "date-fns";
import { GetCustomerLedger, GetSaleRegister, GetSaleSummaryByCustomerAndProductReport } from "../../Services/ReportService";
import {
    ExportFilesFunction,
    getSingleSelected,
    numberFormat,
} from "../../shared/CommonFuctions";
import SplashComponent from "../../Navigation/splash";
import {
    ExpandLess,
    ExpandMore,
    KeyboardArrowDownSharp,
} from "@mui/icons-material";
import { GetBuyerList } from "../../Services/BuyerService";
import MultiSelectSim from "../../Components/MultiSelectSimple";
import { GetCustomerLedgerList, GetSaleRegisterList } from "../../Services/Register";
import PaginationAdvance from "../../Components/PaginationAdvance";
import MultiSelect from "../../Components/MultiSelect";
import { EncryptDecryptService } from "../../Services/common/EncryptionService";
import { useLocation, useNavigate } from "react-router-dom";
import CustomDateRangePicker from "../../Components/CustomDateRange";
import { REPOR_FONTSIZE_OPTION } from "../../StaticData/DataHelper";
import Select from "react-select";
import { LoadingButton } from "@mui/lab";
import { GetSaleSummaryByCustomerAndProduct } from "../../Services/SaleService";
import { GetProductCompanyList } from "../../Services/ProductCompanyService";

interface IBuyer {
    buyerId: number;
    consumerId: number;
    firmId: number;
    organizationName: string;
    firstName: string;
    lastName: string;
    fullName: string;
    address1: string;
    address2: string;
    city: string;
    code: string;
    contactNumber: string;
    state: number;
    stateName: string;
    stateCode: string;
    country: number;
    email: string;
    taxNumber: string;
    type: number;
    label: string;
    value: string;
}

export default function SalesSummaryByCustomerAndProductReport() {
    const matches = useMediaQuery("(max-width:599px)");
    const tabMatches = useMediaQuery("(max-width:768px)");
    const edService = new EncryptDecryptService();
    const navigate = useNavigate();
    const [anchorEl0, setAnchorEl0] = React.useState<HTMLButtonElement | null>(null);
    const theme = useTheme();
    const [checkedPageBreak, setcheckedPageBreak] = React.useState(false);
    const handleChangePageBreak = (event: React.ChangeEvent<HTMLInputElement>) => {
        setcheckedPageBreak(event.target.checked);
    };
    const mobileScreen = useMediaQuery(theme.breakpoints.down("sm"));
    const [page_Index, setPage_Index] = useState(1);
    const [page_Size, setPage_Size] = useState<any>(10);
    const [fontSizeSelection, setFontSizeSelection] = useState<number>(8);
    const [counData, setCounData] = useState(0);
    const [totalCount, setTotalCount] = useState(0);
    const [pageStartIndex, setPageStartIndex] = useState(1);
    const [pageEndIndex, setPageEndIndex] = useState(1);
    const [sourceBuyerCollection, setsourceBuyerCollection] = React.useState(() => {
        let coll: IBuyer[] = [];
        return coll;
    });
    const { userContext, updateUserContext } = useContext(PreferencesContext);
    const [isLoading, setLoading] = React.useState(false);
    const [selectedDateRange, setDateRange] = useState([
        {
            startDate: new Date(userContext.financialYearStartDate),
            endDate: new Date(),
            key: "selection",
        },
    ]);
    const [openBuyer, setopenBuyer] = React.useState<any>([]);
    const [selectedBuyersId, setSelectedBuyerId] = React.useState<any>([]);
    const [selectedBuyerIdData, setSelectedBuyerIdData] = React.useState<any>([]);
    const [productCompanyCollection, setProductCompanyCollection] = useState<any>([]);
    const [selectedProductCompanies, setSelectedProductCompanies] = useState<any>([]);
    const [selectedProductCompanyIdData, setSelectedProductCompanyIdData] = useState<any>([]);
    const [isCollapsed, setIsCollapsed] = React.useState<any>(true);
    const [anchorEl2, setAnchorEl2] = React.useState<null | HTMLElement>(null);
    const openExportType = Boolean(anchorEl2);
    const [Curr_page, setCurrPage] = useState(1);
    const [resultData, setResultData] = useState<any>({
        saleSummaryByCustomerAndProductListCollection: [],
        saleSummaryByCustomerAndProductDetailCollection: [],
    });

    const handleClickExportType = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorEl2(event.currentTarget);
    };
    const [fromDate, setFromDate] = React.useState<any>(userContext.financialYearStartDate);
    const [toDate, setToDate] = React.useState<any>(userContext.financialYearEndDate);

    const parameters: any = {
        consumerId: 1,
        startDate: "",
        endDate: "",
        pageIndex: page_Index,
        pageSize: page_Size,
        sortColumn: "",
        sortDirection: "",
        searchValue: "",
    };
    const [param, setParam] = useState(parameters);

    function useQuery() {
        const { search } = useLocation();
        return React.useMemo(() => new URLSearchParams(search), [search]);
    }
    let urlParams = useQuery();
    let tempEncryptedConvertTimeBuyerId = urlParams.get("q");
    let decryptBuyerId: any = edService.decrypt(tempEncryptedConvertTimeBuyerId);
    let convertedBuyerId: any = parseInt(decryptBuyerId) || 0;

    const handleChange = (object: any) => {
        setSelectedBuyerId(object);
        let tempBuyerIdData: any = [];
        object.forEach((x) => {
            if (x?.value === "*") {
                return;
            } else {
                let buyerIds = x.buyerId;
                x.buyerId = buyerIds;
                tempBuyerIdData.push(buyerIds.toString());
            }
        });
        setSelectedBuyerIdData(tempBuyerIdData);
    };

    const handleCompanyChange = (object: any) => {
        setSelectedProductCompanies(object);
        let tempCompanyIdData: any = [];
        object.forEach((x: any) => {
            if (x?.value === "*") {
                return;
            } else {
                let companyId = x.productCompanyId || x.value;
                tempCompanyIdData.push(companyId.toString());
            }
        });
        setSelectedProductCompanyIdData(tempCompanyIdData);
    };

    const handleCloseExportType = () => {
        setAnchorEl2(null);
    };

    const handleChangePageNew = (
        event: React.MouseEvent<HTMLButtonElement> | null,
        value: number
    ) => {
        if (Curr_page !== value) {
            setCurrPage(value);
            setPage_Index(value);
            fetchCustomerProductSummaryReportList();
        }
    };

    type PageSizeChangeEvent = {
        value: string;
        label: string;
    };

    const handlePageSizeCahange = (event: PageSizeChangeEvent) => {
        if (event !== null) {
            setPage_Size(event.value);
            setPage_Index(1);
            setCurrPage(1);
        }
    };

    const StyledMenu = styled((props: MenuProps) => (
        <Menu
            elevation={0}
            anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
            transformOrigin={{ vertical: "top", horizontal: "right" }}
            {...props}
        />
    ))(({ theme }) => ({
        "& .MuiPaper-root": {
            borderRadius: 6,
            marginTop: theme.spacing(1),
            minWidth: 50,
            color:
                theme.palette.mode === "light"
                    ? "rgb(55, 65, 81)"
                    : theme.palette.grey[300],
            boxShadow:
                "rgb(255, 255, 255) 0px 0px 0px 0px, rgba(0, 0, 0, 0.05) 0px 0px 0px 1px, rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px",
            "& .MuiMenu-list": { padding: "4px 0" },
            "& .MuiMenuItem-root": {
                "& .MuiSvgIcon-root": {
                    fontSize: 18,
                    color: theme.palette.text.secondary,
                    marginRight: theme.spacing(1.5),
                },
                "&:active": {
                    backgroundColor: alpha(
                        theme.palette.primary.main,
                        theme.palette.action.selectedOpacity
                    ),
                },
            },
        },
    }));

    const handleDateRangePickerOpen = (event: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorEl0(event.currentTarget);
    };
    const handleClosepopover = () => {
        setAnchorEl0(null);
    };
    function handleDateRange(selected: any) {
        setDateRange(selected);
    }

    async function getBuyers(onInit, searchValue) {
        let params = new URLSearchParams();
        let buyerCollectionData: any;
        params.append("consumerId", userContext.consumerId.toString());
        params.append("firmId", userContext.firmId.toString());
        params.append("branchId", userContext.branchId.toString());
        params.append("pageIndex", parameters.pageIndex.toString());
        params.append("pageSize", "1000");
        params.append("sortColumn", parameters.sortColumn);
        params.append("sortDirection", parameters.sortDirection);
        params.append("searchValue", searchValue);
        params.append("mode", "");
        params.append("financialYear", userContext.financialYear?.toString());
        try {
            const result: any = await GetBuyerList(params);
            if (result) {
                buyerCollectionData = result?.data?.data?.buyerCollection;
                if (buyerCollectionData) setsourceBuyerCollection(buyerCollectionData);
            }
        } catch (error) {
            console.log(error);
        }
        return buyerCollectionData;
    }

    async function fetchProductCompanyList() {
        let params = new URLSearchParams();
        let companyCollectionData: any;
        params.append("consumerId", userContext.consumerId.toString());
        params.append("firmId", userContext.firmId.toString());
        params.append("branchId", userContext.branchId.toString());
        params.append("pageIndex", "1");
        params.append("pageSize", "1000");
        params.append("sortColumn", "");
        params.append("sortDirection", "");
        params.append("searchValue", "");
        params.append("mode", "DROPDOWN");
        try {
            const result: any = await GetProductCompanyList(params);
            if (result) {
                companyCollectionData = result?.data?.data?.productCompanyCollection;
                if (companyCollectionData) setProductCompanyCollection(companyCollectionData);
            }
        } catch (error) {
            console.log(error);
        }
        return companyCollectionData;
    }

    async function openInvoiceLedgerReportPopup(type: any) {
        let saleTypeId;
        if (userContext.enableCompositionTax === true) {
            saleTypeId = 102;
        } else {
            saleTypeId = 1;
        }
        let pageBreak: string;
        if (checkedPageBreak === true) {
            pageBreak = "SaleSummaryByCustomerAndProductPageBreak";
        } else {
            pageBreak = "SaleSummaryByCustomerAndProductReport";
        }
        setAnchorEl2(null);
        setLoading(true);
        var attachmentName = "";
        if (type === "pdf") {
            attachmentName =
                "SaleSummaryByCustomerAndProduct" +
                format(new Date(selectedDateRange[0].startDate), "_yyyyMMdd") +
                format(new Date(selectedDateRange[0].endDate), "_yyyyMMdd") +
                ".pdf";
        } else {
            attachmentName =
                "SaleSummaryByCustomerAndProduct" +
                format(new Date(selectedDateRange[0].startDate), "_yyyyMMdd") +
                format(new Date(selectedDateRange[0].endDate), "_yyyyMMdd") +
                ".xls";
        }
        let params = new URLSearchParams();
        params.append("reportName", pageBreak);
        params.append("reportType", type);
        params.append("consumerId", userContext.consumerId.toString());
        params.append("branchId", userContext.branchId.toString());
        params.append("firmId", userContext.firmId.toString());
        params.append("buyerIds", selectedBuyerIdData);
        if (selectedProductCompanyIdData !== null && selectedProductCompanyIdData !== undefined && selectedProductCompanyIdData.length > 0) {
            params.append("productCompanyIds", selectedProductCompanyIdData);
        }
        // params.append("fontSize", fontSizeSelection.toString());
        params.append("pageSize", page_Size);
        params.append("pageIndex", page_Index.toString());
        params.append("financialYear", userContext.financialYear.toString());
        params.append("startDate", format(new Date(fromDate), "yyyy-MM-dd"));
        params.append("endDate", format(new Date(toDate), "yyyy-MM-dd"));
        params.append("fileName", attachmentName);
        params.append("mode", "Export");
        params.append("isForDownload", '1');
        try {
            const result: any = await GetSaleSummaryByCustomerAndProductReport(params);
            if (result && result.data && result.data.data) {
                var fileContent = result?.data?.data?.fileData;
                var attachmentData = fileContent;
                ExportFilesFunction(attachmentName, type, attachmentData);
                setLoading(false);
            }
            setLoading(false);
        } catch (e: any) {
            setLoading(false);
            updateUserContext({
                ...userContext,
                isAlert: true,
                alertMessage:
                    typeof e === "string" ? (e as string) : (e?.message as string),
                alertType: AlertType.Error,
            });
        }
    }
    const fetchCustomerProductSummaryReportList = async () => {
        let params = new URLSearchParams();
        params.append("consumerId", userContext.consumerId.toString());
        params.append("branchId", userContext.branchId.toString());
        params.append("firmId", userContext.firmId.toString());
        params.append("pageIndex", page_Index.toString());
        params.append("pageSize", page_Size);
        if (selectedBuyerIdData !== null) {
            params.append("buyerIds", selectedBuyerIdData);
        }
        if (selectedProductCompanyIdData !== null && selectedProductCompanyIdData !== undefined && selectedProductCompanyIdData.length > 0) {
            params.append("productCompanyIds", selectedProductCompanyIdData);
        }
        params.append("financialYear", userContext.financialYear.toString());
        params.append("startDate", format(new Date(fromDate), "yyyy-MM-dd"));
        params.append("endDate", format(new Date(toDate), "yyyy-MM-dd"));
        setLoading(true);

        try {
            const result: any = await GetSaleSummaryByCustomerAndProduct(params);
            if (result?.data?.data) {
                const responseData = result.data.data;
                const buyerList =
                    responseData?.saleSummaryByCustomerAndProductListCollection ?? [];
                const productList =
                    responseData?.saleSummaryByCustomerAndProductDetailCollection ?? [];

                setResultData({
                    saleSummaryByCustomerAndProductListCollection: buyerList,
                    saleSummaryByCustomerAndProductDetailCollection: productList,
                });
                let dataCount = buyerList.length;
                let showDataCount = Math.ceil(dataCount / page_Size);
                setCounData(showDataCount);
                setTotalCount(dataCount);
                let startIndex = (page_Index - 1) * page_Size + 1;
                let endIndex = Math.min(page_Index * page_Size, dataCount);
                setPageStartIndex(startIndex);
                setPageEndIndex(endIndex);
            }
            setLoading(false);
        } catch (error: any) {
            setLoading(false);
            updateUserContext({
                ...userContext,
                isAlert: true,
                alertMessage:
                    typeof error === "string"
                        ? (error as string)
                        : (error?.message as string),
                alertType: AlertType.Error,
            });
        }
    };

    useEffect(() => {
        const BuyerIds = async () => {
            const buyerData = await getBuyers(true, "");
            if (convertedBuyerId > 0 && convertedBuyerId) {
                const filteroption: any = buyerData?.filter((x) => {
                    return x.buyerId === convertedBuyerId;
                });
                setSelectedBuyerId(filteroption);
                setSelectedBuyerIdData(convertedBuyerId);
                handleChange(filteroption);
            }
        };
        BuyerIds();
    }, []);

    useEffect(() => {
        getBuyers(true, "");
        fetchProductCompanyList();
    }, []);

    const handleBack = () => {
        navigate(-1);
    };

    useEffect(() => {
        if (selectedBuyersId !== null && selectedBuyersId !== undefined) {
            fetchCustomerProductSummaryReportList();
        }
    }, [
        fromDate,
        toDate,
        selectedBuyerIdData,
        selectedProductCompanyIdData,
        selectedDateRange,
        page_Size,
        page_Index,
    ]);

    const handleClickBuyer = (buyerId: any) => {
        if (openBuyer?.includes(buyerId)) {
            setopenBuyer(openBuyer?.filter((item) => item !== buyerId));
        } else {
            setopenBuyer([...openBuyer, buyerId]);
        }
    };

    const handleFontSizeCahange = (e: any) => {
        setFontSizeSelection(e?.value);
    };

    const hasSelectedBuyers = selectedBuyersId?.length > 0;

    const grandTotalQuantity = hasSelectedBuyers
        ? resultData?.saleSummaryByCustomerAndProductDetailCollection?.reduce(
            (sum: number, x: any) => sum + (Number(x.quantity) || 0),
            0
          ) ?? 0
        : 0;

    const grandTotalFreeQuantity = hasSelectedBuyers
        ? resultData?.saleSummaryByCustomerAndProductDetailCollection?.reduce(
            (sum: number, x: any) => sum + (Number(x.freeQuantity) || 0),
            0
          ) ?? 0
        : 0;

    const grandTotalAmount = hasSelectedBuyers
        ? resultData?.saleSummaryByCustomerAndProductDetailCollection?.reduce(
            (sum: number, x: any) => sum + (Number(x.amount) || 0),
            0
          ) ?? 0
        : 0;

    return (
        <>
            <Backdrop
                sx={{
                    color: "#fff",
                    backgroundColor: "#fff",
                    zIndex: (theme) => theme.zIndex.drawer + 1,
                }}
                open={isLoading}
            >
                <SplashComponent />
            </Backdrop>
            <Title pageTitle="Sales Summary By Customer And Product" />
            <Box
                className="boxContainer"
                sx={{ "& > :not(style)": { width: "100%" } }}
            >
                {userContext.consumerId > 0 ? (
                    <Grid>
                        <Grid item xs={12}>
                            <Grid
                                container
                                className="title-button-responsive"
                                sx={{
                                    display: "flex !important",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                    flexWrap: "wrap",
                                    gap: 2,
                                }}
                            >
                                <h4 className="page-title" style={{ margin: 0 }}>
                                    Sales Summary By Customer And Product
                                </h4>
                                <Grid
                                    item
                                    display={"flex"}
                                    gap={2}
                                    alignItems={"center"}
                                    sx={{ ml: "auto" }}
                                >
                                    {!matches && (
                                        <>
                                            <Box sx={{ display: "flex", flexDirection: "column" }}>
                                                <Typography className="font-size-12">Total Quantity</Typography>
                                                <Box
                                                    className="inner-tabs tab-warning"
                                                    sx={{
                                                        width: "max-content",
                                                    }}>
                                                    {numberFormat(grandTotalQuantity, 3, 3)}
                                                </Box>
                                            </Box>
                                            {userContext.enableFreeQuantity && (
                                                <Box sx={{ display: "flex", flexDirection: "column" }}>
                                                    <Typography className="font-size-12">Total Free Qty.</Typography>
                                                    <Box
                                                        className="inner-tabs tab-warning"
                                                        sx={{
                                                            width: "max-content",
                                                        }}>
                                                        {numberFormat(grandTotalFreeQuantity, 3, 3)}
                                                    </Box>
                                                </Box>
                                            )}
                                            <Box sx={{ display: "flex", flexDirection: "column" }}>
                                                <Typography className="font-size-12">Total Amount</Typography>
                                                <Box
                                                    className="inner-tabs tab-success"
                                                    sx={{
                                                        width: "max-content",
                                                    }}>
                                                    ₹{numberFormat(grandTotalAmount)}
                                                </Box>
                                            </Box>
                                        </>
                                    )}
                                    <LoadingButton
                                        variant="outlined"
                                        onClick={handleBack}
                                        sx={{ mb: 1 }}
                                    >
                                        <ShortcutButton label="ESC" />
                                        Back
                                    </LoadingButton>
                                </Grid>
                            </Grid>
                            {matches && (
                                <Box
                                    sx={{
                                        mt: 1,
                                        textAlign: "end",
                                        display: "flex",
                                        flexFlow: "row wrap",
                                        gap: 1,
                                        width: "100%",
                                        justifyContent: "end",
                                    }}>
                                    <Box sx={{ textAlign: "right" }}>
                                        <Typography className="font-size-12">Total Quantity</Typography>
                                        <Box
                                            className="inner-tabs tab-warning"
                                            sx={{ width: "max-content" }}>
                                            {numberFormat(grandTotalQuantity, 3, 3)}
                                        </Box>
                                    </Box>
                                    {userContext.enableFreeQuantity && (
                                        <Box sx={{ textAlign: "right" }}>
                                            <Typography className="font-size-12">Total Free Qty.</Typography>
                                            <Box
                                                className="inner-tabs tab-warning"
                                                sx={{ width: "max-content" }}>
                                                {numberFormat(grandTotalFreeQuantity, 3, 3)}
                                            </Box>
                                        </Box>
                                    )}
                                    <Box sx={{ textAlign: "right" }}>
                                        <Typography className="font-size-12">Total Amount</Typography>
                                        <Box
                                            className="inner-tabs tab-success"
                                            sx={{ width: "max-content" }}>
                                            ₹{numberFormat(grandTotalAmount)}
                                        </Box>
                                    </Box>
                                </Box>
                            )}
                        </Grid>

                        <Grid className="paper top-space" sx={{ marginTop: "10px" }}>
                            <Paper elevation={4} className="paper-container">
                                <Grid container spacing={0.5} className="search-space">
                                    <Grid
                                        item
                                        marginTop={matches ? 1 : 0}
                                        xs={12}
                                        sm={12}
                                        md={3}
                                        lg={3}
                                        xl={3}
                                    >
                                        <span
                                            className="d-inline-block"
                                            data-toggle="popover"
                                            data-trigger="focus"
                                            data-content="Please select account(s)"
                                        >
                                            <MultiSelect
                                                placeholderLabel="Customers"
                                                options={sourceBuyerCollection}
                                                onChange={handleChange}
                                                value={selectedBuyersId}
                                                isSelectAll={true}
                                            />
                                        </span>
                                    </Grid>

                                    <Grid
                                        item
                                        marginTop={matches ? 1 : 0}
                                        xs={12}
                                        sm={12}
                                        md={3}
                                        lg={3}
                                        xl={3}
                                    >
                                        <span
                                            className="d-inline-block"
                                            data-toggle="popover"
                                            data-trigger="focus"
                                            data-content="Please select company(s)"
                                        >
                                            <MultiSelect
                                                placeholderLabel="Product Company"
                                                options={productCompanyCollection}
                                                onChange={handleCompanyChange}
                                                value={selectedProductCompanies}
                                                isSelectAll={true}
                                            />
                                        </span>
                                    </Grid>

                                    <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                                        <Grid
                                            sx={{
                                                display: "flex",
                                                justifyContent: { xs: "stretch", md: "flex-end" },
                                                alignItems: {
                                                    xs: "stretch",
                                                    md: "flex-start",
                                                    lg: "center",
                                                },
                                                gap: "5px",
                                                flexWrap: "wrap",
                                                "& > div, & > button, & > Box": {
                                                    width: { xs: "100%", md: "auto" },
                                                },
                                            }}
                                        >
                                            <Button
                                                className="button-responsive"
                                                variant="outlined"
                                                disabled={
                                                    selectedBuyersId === null ||
                                                    selectedBuyersId === undefined ||
                                                    selectedBuyersId.length === 0 ||
                                                    sourceBuyerCollection.length === 0
                                                }
                                                onClick={(e) => {
                                                    e.preventDefault();
                                                    if (isCollapsed) {
                                                        setopenBuyer(
                                                            resultData?.saleSummaryByCustomerAndProductListCollection?.map(
                                                                (item: any) => item?.buyerId
                                                            )
                                                        );
                                                    } else {
                                                        setopenBuyer([]);
                                                    }
                                                    setIsCollapsed(!isCollapsed);
                                                }}
                                            >
                                                {isCollapsed ? "expand" : "collapse"}
                                            </Button>

                                            <CustomDateRangePicker
                                                fromDate={fromDate}
                                                setFromDate={setFromDate}
                                                toDate={toDate}
                                                setToDate={setToDate}
                                                disabled={
                                                    selectedBuyersId === null ||
                                                    selectedBuyersId === undefined ||
                                                    selectedBuyersId.length === 0 ||
                                                    sourceBuyerCollection.length === 0
                                                }
                                            />

                                            <FormControlLabel
                                                control={
                                                    <Checkbox
                                                        onChange={handleChangePageBreak}
                                                        disabled={
                                                            selectedBuyersId === null ||
                                                            selectedBuyersId === undefined ||
                                                            selectedBuyersId.length === 0 ||
                                                            sourceBuyerCollection.length === 0
                                                        }
                                                    />
                                                }
                                                label="Page Break"
                                            />

                                            {/* <Select
                                                options={REPOR_FONTSIZE_OPTION}
                                                theme={(theme) => ({
                                                    ...theme,
                                                    colors: {
                                                        ...theme.colors,
                                                        primary: "#25258f",
                                                        primary25: "#ecebef",
                                                        primary50: "#e1dfea",
                                                    },
                                                })}
                                                onChange={handleFontSizeCahange}
                                                value={getSingleSelected(
                                                    fontSizeSelection.toString(),
                                                    REPOR_FONTSIZE_OPTION
                                                )}
                                                isDisabled={
                                                    selectedBuyersId === null ||
                                                    selectedBuyersId === undefined ||
                                                    selectedBuyersId.length === 0 ||
                                                    sourceBuyerCollection.length === 0
                                                }
                                            /> */}

                                            {/* EXPORT button */}
                                            <Button
                                                className="button-responsive"
                                                aria-controls={
                                                    openExportType ? "demo-customized-menu" : undefined
                                                }
                                                aria-haspopup="true"
                                                aria-expanded={openExportType ? "true" : undefined}
                                                variant="outlined"
                                                disableElevation
                                                disabled={
                                                    selectedBuyersId === null ||
                                                    selectedBuyersId === undefined ||
                                                    selectedBuyersId.length === 0 ||
                                                    sourceBuyerCollection.length === 0
                                                }
                                                onClick={handleClickExportType}
                                                startIcon={<DownloadIcon />}
                                                endIcon={<KeyboardArrowDownSharp />}
                                            >
                                                Export
                                            </Button>
                                            <StyledMenu
                                                id="demo-customized-menu"
                                                MenuListProps={{
                                                    "aria-labelledby": "demo-customized-button",
                                                }}
                                                anchorEl={anchorEl2}
                                                open={openExportType}
                                                onClose={handleCloseExportType}
                                            >
                                                <MenuItem
                                                    disableRipple
                                                    onClick={() => openInvoiceLedgerReportPopup("pdf")}
                                                >
                                                    PDF
                                                </MenuItem>
                                                <MenuItem
                                                    disableRipple
                                                    onClick={() => openInvoiceLedgerReportPopup("Excel")}
                                                >
                                                    EXCEL
                                                </MenuItem>
                                            </StyledMenu>
                                        </Grid>
                                    </Grid>
                                </Grid>
                                <Paper elevation={4} className="paper-container">
                                    {selectedBuyersId?.length > 0 ? (
                                        <>
                                            {resultData?.saleSummaryByCustomerAndProductListCollection
                                                ?.length > 0 &&
                                                resultData.saleSummaryByCustomerAndProductListCollection.map(
                                                    (buyerData: any, index: number) => {
                                                        const isOpen = openBuyer?.includes(buyerData?.buyerId);

                                                        return (
                                                            <React.Fragment key={index}>
                                                                <List component="div" disablePadding>
                                                                    <ListItemButton
                                                                        sx={{
                                                                            borderTop:
                                                                                index !== 0
                                                                                    ? "1px solid #e9e9ef"
                                                                                    : "none",
                                                                            "&:hover": {
                                                                                backgroundColor: "#f1f6fe",
                                                                            },
                                                                            backgroundColor: isOpen
                                                                                ? "#f1f6fe"
                                                                                : "#fff",
                                                                        }}
                                                                        onClick={(e) => {
                                                                            e.preventDefault();
                                                                            handleClickBuyer(buyerData?.buyerId);
                                                                        }}
                                                                    >
                                                                        {isOpen ? (
                                                                            <ExpandLess sx={{ mr: 1 }} />
                                                                        ) : (
                                                                            <ExpandMore sx={{ mr: 1 }} />
                                                                        )}
                                                                        <Box
                                                                            sx={{
                                                                                display: "flex",
                                                                                gap: 2,
                                                                                width: "100%",
                                                                                flexWrap: "wrap",
                                                                            }}
                                                                        >
                                                                            <Box
                                                                                display={"flex"}
                                                                                sx={{
                                                                                    width: !tabMatches ? "33%" : "100%",
                                                                                }}
                                                                            >
                                                                                <Typography sx={{ fontWeight: 700 }}>
                                                                                    {buyerData?.buyerName}
                                                                                </Typography>
                                                                            </Box>
                                                                        </Box>
                                                                    </ListItemButton>
                                                                    <Collapse
                                                                        in={isOpen}
                                                                        timeout="auto"
                                                                        unmountOnExit
                                                                    >
                                                                        <TableContainer>
                                                                            <Table aria-labelledby="tableTitle">
                                                                                {/* Table Header */}
                                                                                <TableHead className="table-header-color">
                                                                                    <TableRow>
                                                                                        <TableCell
                                                                                            sx={{ fontWeight: "bold" }}
                                                                                            align="left"
                                                                                        >
                                                                                            Product Name
                                                                                        </TableCell>
                                                                                        <TableCell
                                                                                            sx={{ fontWeight: "bold" }}
                                                                                            align="right"
                                                                                        >
                                                                                            Quantity
                                                                                        </TableCell>
                                                                                        {userContext.enableFreeQuantity && (
                                                                                            <TableCell
                                                                                                sx={{ fontWeight: "bold" }}
                                                                                                align="right"
                                                                                            >
                                                                                                Free Quantity
                                                                                            </TableCell>
                                                                                        )}
                                                                                        <TableCell
                                                                                            sx={{
                                                                                                fontWeight: "bold",
                                                                                                minWidth: "121px",
                                                                                            }}
                                                                                            align="right"
                                                                                        >
                                                                                            Rate
                                                                                        </TableCell>
                                                                                        <TableCell
                                                                                            sx={{
                                                                                                fontWeight: "bold",
                                                                                                minWidth: "121px",
                                                                                            }}
                                                                                            align="right"
                                                                                        >
                                                                                            Amount
                                                                                        </TableCell>
                                                                                    </TableRow>
                                                                                </TableHead>

                                                                                <TableBody>
                                                                                    {(() => {
                                                                                        const buyerDetails = resultData?.saleSummaryByCustomerAndProductDetailCollection?.filter(
                                                                                            (x: any) => x.buyerId === buyerData?.buyerId
                                                                                        ) ?? [];

                                                                                        if (buyerDetails.length === 0) {
                                                                                            return (
                                                                                                <TableRow>
                                                                                                    <TableCell
                                                                                                        colSpan={userContext.enableFreeQuantity ? 5 : 4}
                                                                                                        align="center"
                                                                                                    >
                                                                                                        No record(s) found
                                                                                                    </TableCell>
                                                                                                </TableRow>
                                                                                            );
                                                                                        }

                                                                                        const totalQuantity = buyerDetails.reduce((sum: number, x: any) => sum + (Number(x.quantity) || 0), 0);
                                                                                        const totalFreeQuantity = buyerDetails.reduce((sum: number, x: any) => sum + (Number(x.freeQuantity) || 0), 0);
                                                                                        const totalAmount = buyerDetails.reduce((sum: number, x: any) => sum + (Number(x.amount) || 0), 0);

                                                                                        return (
                                                                                            <>
                                                                                                {buyerDetails.map((saleDetailData: any, detailIndex: number) => (
                                                                                                    <TableRow
                                                                                                        key={saleDetailData.rowId ?? detailIndex}
                                                                                                        sx={{
                                                                                                            "&:hover": {
                                                                                                                backgroundColor: "#f1f6fe",
                                                                                                                cursor: "pointer",
                                                                                                            },
                                                                                                        }}
                                                                                                    >
                                                                                                        <TableCell align="left">
                                                                                                            {saleDetailData?.productName}
                                                                                                        </TableCell>
                                                                                                        <TableCell align="right">
                                                                                                            {numberFormat(saleDetailData?.quantity, 3, 3)}
                                                                                                        </TableCell>
                                                                                                        {userContext.enableFreeQuantity && (
                                                                                                            <TableCell align="right">
                                                                                                                {numberFormat(saleDetailData?.freeQuantity, 3, 3)}
                                                                                                            </TableCell>
                                                                                                        )}
                                                                                                        <TableCell align="right">
                                                                                                            {numberFormat(saleDetailData?.rate)}
                                                                                                        </TableCell>
                                                                                                        <TableCell align="right">
                                                                                                            {numberFormat(saleDetailData?.amount)}
                                                                                                        </TableCell>
                                                                                                    </TableRow>
                                                                                                ))}
                                                                                                <TableRow sx={{ backgroundColor: "#f5f5f5" }}>
                                                                                                    <TableCell align="left" sx={{ fontWeight: "bold" }}>
                                                                                                        Total
                                                                                                    </TableCell>
                                                                                                    <TableCell align="right" sx={{ fontWeight: "bold" }}>
                                                                                                        {numberFormat(totalQuantity, 3, 3)}
                                                                                                    </TableCell>
                                                                                                    {userContext.enableFreeQuantity && (
                                                                                                        <TableCell align="right" sx={{ fontWeight: "bold" }}>
                                                                                                            {numberFormat(totalFreeQuantity, 3, 3)}
                                                                                                        </TableCell>
                                                                                                    )}
                                                                                                    <TableCell align="right" sx={{ fontWeight: "bold" }}>
                                                                                                        {/* Rate empty for Total */}
                                                                                                    </TableCell>
                                                                                                    <TableCell align="right" sx={{ fontWeight: "bold" }}>
                                                                                                        {numberFormat(totalAmount)}
                                                                                                    </TableCell>
                                                                                                </TableRow>
                                                                                            </>
                                                                                        );
                                                                                    })()}
                                                                                </TableBody>
                                                                            </Table>
                                                                        </TableContainer>
                                                                    </Collapse>
                                                                </List>
                                                            </React.Fragment>
                                                        );
                                                    }
                                                )}

                                            {/* Pagination */}
                                            {resultData?.saleSummaryByCustomerAndProductListCollection
                                                ?.length > 0 && (
                                                <Grid
                                                    container
                                                    paddingTop={1}
                                                    alignItems={"center"}
                                                    justifyContent={"center"}
                                                >
                                                    <Grid
                                                        item
                                                        xs={12}
                                                        sm={6}
                                                        className="pagination-label"
                                                    >
                                                        {pageStartIndex} - {pageEndIndex} of {totalCount}
                                                    </Grid>
                                                    <Grid item xs={12} sm={6}>
                                                        <Stack
                                                            component="div"
                                                            alignItems={mobileScreen ? "center" : "end"}
                                                            justifyContent={"center"}
                                                        >
                                                            <PaginationAdvance
                                                                page_Size={page_Size}
                                                                handlePageSizeCahange={(e) => {
                                                                    handlePageSizeCahange(e);
                                                                }}
                                                                counData={counData}
                                                                page_Index={page_Index}
                                                                handleChangePageIndex={handleChangePageNew}
                                                            />
                                                        </Stack>
                                                    </Grid>
                                                </Grid>
                                            )}

                                            {/* No data message */}
                                            {resultData?.saleSummaryByCustomerAndProductListCollection
                                                ?.length <= 0 && (
                                                <Typography
                                                    sx={{
                                                        width: "100%",
                                                        display: "flex",
                                                        justifyContent: "center",
                                                    }}
                                                >
                                                    No Data is Available.
                                                </Typography>
                                            )}
                                        </>
                                    ) : (
                                        <Typography
                                            sx={{
                                                width: "100%",
                                                display: "flex",
                                                justifyContent: "center",
                                            }}
                                        >
                                            Customer is Not Selected.
                                        </Typography>
                                    )}
                                </Paper>
                            </Paper>
                        </Grid>
                    </Grid>
                ) : (
                    <MissingConsumer consumerId={userContext.consumerId} />
                )}
            </Box>
        </>
    );
}